import { createContext } from 'react';

export const JobContext = createContext();
export const JobSavingContext = createContext(false);